import React from "react";
import { Collapse as AntCollapse } from 'antd'
import styled from '@emotion/styled'
import {
  FlexCol,
  FlexRow,
  ObjectiveDetailLabel,
  ObjectiveDetailDescription,
  ObjectiveDetail,
} from "./shared";

import { colors } from "Utils";

import {
  // Collapse,
  CollapseHeader,
  ObjectiveButtonList,
  Panel,
} from "Components";

import moment from 'moment';

export const Dealer = ({ 
  dealer, 
  setProps, 
  setFreezeProps, 
  editDealer = () => {}, 
  freezeDealer = () => {}, 
  unfreezeDealer = () => {}
}) => {
  
  const {
    codigoDistribuidor,
    cif,
    razonSocial,
    modifEn,
    poblacion,
    provincia,
    direccionFiscal,
    email,
    codigoPostal,
    codigoProveedorHesa,
    gerente,
    erp,
    user,
    password,
    
    observaciones,
    
    last_login,
    last_transmission_clientes,
    last_transmission_articulos,
    last_transmission_ventas,
    last_transmission_existencias,

    record_type_counts_clientes,
    record_type_counts_articulos,
    record_type_counts_ventas,
    record_type_counts_existencias,

    isActive,
  } = dealer;
  
  const leftDataSource = [
    { label: "Distribuidor", description: codigoDistribuidor },
    { label: "CIF", description: cif },
    { label: "Razón Social", description: razonSocial },
    { label: "Gerente", description: gerente },
    { label: "E-mail", description: email },
    { label: "ERP", description: erp },
  ];

  const centerDataSource = [
    { label: "Proveedor HESA", description: codigoProveedorHesa },
    { label: "Población", description: poblacion },
    { label: "Provincia", description: provincia },
    { label: "Dirección", description: direccionFiscal },
    { label: "C.P.", description: codigoPostal },
    { label: "Observaciones", description: observaciones },
  ];
  
  const rightDataSource = [
    { label: "Última transmisión clientes", description: last_transmission_clientes, quantity: record_type_counts_clientes },
    { label: "Última transmisión artículos", description: last_transmission_articulos, quantity: record_type_counts_articulos },
    { label: "Última transmisión ventas", description: last_transmission_ventas, quantity: record_type_counts_ventas },
    { label: "Última transmisión existencias", description: last_transmission_existencias, quantity: record_type_counts_existencias },
  ];
  
  const sixMonths = moment().subtract(6, 'months').unix() * 1000;

  return (
    <CollapseDealer isActive={isActive} toCheck={last_login < sixMonths} expandIconPosition="end" onChange={() => {}}>
      <Panel className="DealerPanel"
        header={
          <CollapseHeader
            title={`${razonSocial} - ${codigoDistribuidor}`}
            date={modifEn}
            date2={last_login}
            isDistributor={true}
            isActive={isActive}
          />
        }
      >
        <FlexRow>
          <FlexCol span={12} style={{ borderRight: "solid 1px #eaeaea" }}>
            {leftDataSource.map(({ label, description }, index) => (
              <ObjectiveDetail key={`l-${index}`}>
                <ObjectiveDetailLabel>{label}</ObjectiveDetailLabel>
                <ObjectiveDetailDescription>
                  {description ? description : "-"}
                </ObjectiveDetailDescription>
              </ObjectiveDetail>
            ))}
          </FlexCol>
          <FlexCol span={12} style={{ borderRight: "solid 1px #eaeaea" }}>
            {centerDataSource.map(({ label, description }, index) => (
              <ObjectiveDetail key={`c-${index}`}>
                <ObjectiveDetailLabel>{label}</ObjectiveDetailLabel>
                <ObjectiveDetailDescription style={{ wordWrap: 'break-word', maxWidth:'500px' }}>
                  {description ? description : "-"}
                </ObjectiveDetailDescription>
              </ObjectiveDetail>
            ))}
          </FlexCol>
          <FlexCol span={12}>
            {rightDataSource.map(({ label, description, quantity }, index) => (
              <ObjectiveDetail key={`r-${index}`}>
                <ObjectiveDetailLabel>{label}</ObjectiveDetailLabel>
                <ObjectiveDetailDescription>                
                  {(description && description != -62135596800000) ?  `${moment(description).format('DD/MM/YYYY HH:mm:ss')} - ${(quantity>=0)? quantity + ' registros' : 'ERROR'}`: "-"}
                </ObjectiveDetailDescription>
              </ObjectiveDetail>
            ))}
          </FlexCol>
        </FlexRow>
        <ObjectiveButtonList
          onEdit={() =>
            setProps({
              visible: true,
              title: "Editar distribuidor",
              okText: "Editar",
              dataInfo: dealer,
              submit: editDealer,
            })
          }
          onFreeze={() => {
            setFreezeProps({
              visible: true,
              title: dealer.isActive? "Congelar distribuidor" : "Descongelar distribuidor",
              okText: dealer.isActive? "Congelar" : "Descongelar",
              dataInfo: dealer,
              isActive: dealer.isActive,
              submit: dealer.isActive? freezeDealer : unfreezeDealer,
            })
          }}
          isActive={dealer.isActive}
        />
      </Panel>
    </CollapseDealer>
  );
};

export const CollapseDealer = styled(AntCollapse)`
  border-radius: 4px;
  border: solid 1px rgba(0, 0, 0, 0.09);
  margin-bottom: 19px;

  &.ant-collapse-icon-position-right
    > .ant-collapse-item
    > .ant-collapse-header {
    padding: 17px 28px 15px;
  }

  .ant-collapse-header {
    background-color: ${props => props.isActive && props.toCheck? colors.lightYellow : '#f1f1f1' 
    // '#f1f1f1' // El gris de toda la vida
    }; 
    box-shadow: 0 2px 4px 0 rgba(233, 233, 233, 0.5);
    min-height: 76px;
  }

  .ant-collapse-header > .ant-collapse-header-text {
    width: 100%;
  }

  .ant-collapse-content {
    border: none;
  }

  .ant-collapse-content > .ant-collapse-content-box {
    padding: 22px 10px 30px;
  }

  &.ant-collapse-icon-position-right
    > .ant-collapse-item
    > .ant-collapse-header
    .ant-collapse-arrow {
    right: 28px;
  }
`;